export const getAddressFromCheckout = (shipToAddress) => {
    let address;
    const deliveryAddress = shipToAddress.delivery_addresses?.[0];
    if (deliveryAddress) {
        address = {
            email: shipToAddress.email,
            firstName: shipToAddress.first_name,
            lastName: shipToAddress.last_name,
            street: deliveryAddress.line1,
            zipCode: deliveryAddress.zip,
            city: deliveryAddress.city,
            phoneNumber: shipToAddress.cell_phone,
        };
    }

    return address;
};
